import { getDefaultCopies } from '../redux/api/settings-api'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { getCopies } from '@/redux/api/settings-api'

export function useCopies() {
  const dispatch = useAppDispatch()
  const selectedEcommerce = useAppSelector(
    (store) => store.generalData.selectedEcommerce
  )

  const defaultCopiesCall = useAppSelector(
    (store) => store.settingsApi.defaultCopies
  )
  const loadingDefaultCopies = defaultCopiesCall.loading
  const errorDefaultCopies = defaultCopiesCall.error
  const defaultCopies = defaultCopiesCall.response

  const ecommerceCopies = useAppSelector(
    (store) => store.settingsApi.copies.response
  )

  const reloadCopies = () => {
    if (!selectedEcommerce) return
    dispatch(getCopies(selectedEcommerce))
  }

  useEffect(() => {
    dispatch(getDefaultCopies())
  }, [])

  return {
    ecommerceCopies,
    loadingDefaultCopies,
    errorDefaultCopies,
    defaultCopies,
    reloadCopies
  }
}
